export const DataMutation_Shipping_SetShippingAddressesOnCart_QueryKey = {
  shippingSetShippingAddressesOnCart: (): string => {
    const queryKey = "data-mutation--shipping-set-shipping-addresses-on-cart";
    return queryKey;
  },
};
